import { request as _request, updateRequestConfig } from './request';

/**
 * 获取商品列表-观看端
 * @returns
 */
const getProductsList = params => {
  return _request({
    url: `/v3/goods/webinar/get-online-goods`,
    method: 'get',
    params
  });
};
/**
 * 获取回放推送商品-观看端
 * @returns
 */
const getRecordPopGood = params => {
  return _request({
    url: `/v3/goods/webinar/get-pop-goods`,
    method: 'get',
    params
  });
};
/**
 * 获取商品列表-消息更新 - 观看端
 * @param {string} params.url 商品列表
 * @returns
 */
const queryGoodsListJson = params => {
  return _request({
    url: params.url,
    method: 'get',
    params
  });
};

/**
 * 获取商品其他设置-观看端
 * @param {string}
 * @returns
 */
const getProductsOtherInfo = params => {
  return _request({
    url: `/v3/goods/webinar-setting/get-info`,
    method: 'get',
    params
  });
};

/**
 * 获取商户号绑定列表-观看端
 * @param {string}
 * @returns
 */
const getProductsPartner = params => {
  return _request({
    url: `/v3/goods/partner/get-list`,
    method: 'get',
    params
  });
};

/**
 * 提交/创建订单-观看端
 * @param {string} goods_id 商品id
 * @returns
 */
const createProductsOrder = params => {
  return _request({
    url: `/v3/goods/order/create`,
    method: 'post',
    params
  });
};

/**
 * 查询订单-观看端
 * @param {string} order_no 订单号
 * @returns
 */
const getMyOrderInfo = params => {
  return _request({
    url: `/v3/goods/order/my-order-info`,
    method: 'get',
    params
  });
};

/**
 * 查询订单-微信返回-观看端
 * @param {string} order_no 订单号
 * @returns
 */
const getWeixinOrderInfo = params => {
  return _request({
    url: `/v3/goods/order/get-jsapi-order-info`,
    method: 'get',
    params
  });
};

/**
 * 获取商品详情
 * @param {string} goods_id 商品id
 * @returns
 */
const getProductsDetail = params => {
  return _request({
    url: `/v3/goods/webinar/get-online-goods-info`,
    method: 'get',
    params
  });
};

/**
 * 创建商品
 * @param {string} webinar_id 活动id
 * @returns
 */
const createAdminProduct = params => {
  return _request({
    url: `/v3/goods/good/create`,
    method: 'post',
    params
  });
};

/**
 * 控制台账号下商品列表
 * @param {string} webinar_id 活动id
 * @returns
 */
const getAdminProductsList = params => {
  return _request({
    url: `/v3/goods/good/get-list`,
    method: 'get',
    params
  });
};

/**
 * 控制台活动下商品列表
 * @param {string} webinar_id 活动id
 * @param {string} keyword 搜索参数
 * @param {number} pos 分页参数
 * @param {number} limit 分页参数
 * @returns
 */
const getAdminWebinarProductsList = params => {
  return _request({
    url: `/v3/goods/webinar/get-list`,
    method: 'get',
    params
  });
};

/**
 * 控制台活动下资料库商品列表
 * @param {string} webinar_id 活动id
 * @returns
 */
const getAdminUnselectedList = params => {
  return _request({
    url: `/v3/goods/webinar/get-unselected-goods`,
    method: 'get',
    params
  });
};

/**
 * 控制台活动下创建商品
 * @param {string} webinar_id 活动id
 * @param {number[]} goods_ids 商品id集合
 * @param {number} order_num 排序
 * @param {number} status 状态
 * @returns
 */
const createAdminWebinarProduct = params => {
  return _request({
    url: `/v3/goods/webinar/create`,
    method: 'post',
    params
  });
};

/**
 * 控制台账号下商品详情
 * @param {string} goods_id 商品id
 * @returns
 */
const getAdminProductDetail = params => {
  return _request({
    url: `/v3/goods/good/get-info`,
    method: 'get',
    params
  });
};

/**
 * 控制台活动下商品上架设置
 * @param {string} webinar_goods_id 商品id
 * @param {number} status 状态
 * @returns
 */
const setAdminProductStatus = params => {
  return _request({
    url: `/v3/goods/webinar/set-status`,
    method: 'post',
    params
  });
};

/**
 * 控制台活动下商品批量上下架设置
 * @param {string} webinar_goods_id 商品id
 * @param {number} status 状态
 * @returns
 */
const batchChangeStatus = params => {
  return _request({
    url: `/v3/goods/webinar/batch-change-status`,
    method: 'post',
    params
  });
};

/**
 * 控制台账号下修改商品信息
 * @returns
 */
const updateAdminProduct = params => {
  return _request({
    url: `/v3/goods/good/update`,
    method: 'post',
    params
  });
};

/**
 * 控制台账号下删除商品信息
 * @returns
 */
const deleteAdminProduct = params => {
  return _request({
    url: `/v3/goods/good/batch-delete`,
    method: 'post',
    params
  });
};

/**
 * 控制台账号下复制商品信息
 * @returns
 */
const copyAdminProduct = params => {
  return _request({
    url: `/v3/goods/good/clone`,
    method: 'post',
    params
  });
};

/**
 * 控制台活动下删除商品信息
 * @returns
 */
const deleteWebinarProduct = params => {
  return _request({
    url: `/v3/goods/webinar/batch-delete`,
    method: 'post',
    params
  });
};

/**
 * 控制台活动下商品排序
 * @returns
 */
const setWebinarProductOrder = params => {
  return _request({
    url: `/v3/goods/webinar/set-order-num`,
    method: 'post',
    params
  });
};

/**
 * 控制台活动下其他设置
 * @returns
 */
const setWebinarProductSetting = params => {
  return _request({
    url: `/v3/goods/webinar-setting/save-setting`,
    method: 'post',
    params
  });
};

/**
 * 控制台活动下其他设置
 * @returns
 */
const getWebinarProductSetting = params => {
  // 控制台设置全局env的时候header待token
  return _request({
    url: `/v3/goods/webinar-setting/setting-info`,
    method: 'get',
    params
  });
};

/**
 * 控制台保存全局商品其它设置：直播互动 - 商品-其他设置（全局设置)
 * @returns
 */
const setProductSettingInGlobal = params => {
  return _request({
    url: `/v3/goods/user-setting/set`,
    method: 'post',
    params
  });
};

/**
 控制台获取全局商品其它设置：直播互动 - 商品-其他设置（全局设置)
 * @returns
 */
const getProductSettingInGlobal = params => {
  return _request({
    url: `/v3/goods/user-setting/info`,
    method: 'get',
    params
  });
};

/**
 * 控制台获取订单列表
 * @returns
 */
const getOrderList = params => {
  return _request({
    url: `/v3/goods/order/get-list`,
    method: 'get',
    params
  });
};

/**
 * 控制台获取渠道列表
 * @returns
 */
const getChannelList = params => {
  return _request({
    url: `/v3/goods/order/get-channel-list`,
    method: 'get',
    params
  });
};

/**
 * 控制台导出订单列表
 * @returns
 */
const exportOrderList = params => {
  return _request({
    url: `/v3/goods/order/export`,
    method: 'post',
    params
  });
};

/**
 * 控制台获取订单详情
 * @returns
 */
const getOrderInfo = params => {
  return _request({
    url: `/v3/goods/order/get-info`,
    method: 'get',
    params
  });
};

/**
 * 发起端商品推送状态修改
 * @returns
 */
const setPushStatus = params => {
  return _request({
    url: `/v3/goods/webinar/set-push-status`,
    method: 'post',
    params
  });
};

/**
 * 发起端商品销售状态变更（0=售罄，1=销售中（默认）、2=其他...）
 * @param {*} params
 */
const setSaleStatus = params => {
  return _request({
    url: '/v3/goods/webinar/set-sale-status',
    method: 'post',
    params
  });
};

/**
 * 获取可用优惠券列表
 * @returns
 */
const getAvailableList = params => {
  return _request({
    url: `/v3/goods/coupon-webinar/available-list`,
    method: 'post',
    params
  });
};

/**
 * 获取不可用优惠券列表
 * @returns
 */
const getUnavailableList = params => {
  return _request({
    url: `/v3/goods/coupon-webinar/unavailable-list`,
    method: 'post',
    params
  });
};

/**
 * 商品操作上报
 * @param {*} params
 * @returns
 */
const reportGoodsView = params => {
  return _request({
    url: `/v3/goods/good/view/add`,
    method: 'post',
    params
  });
};
const setPushNum = params => {
  return _request({
    url: `/v3/goods/webinar-setting/set-push-show-num`,
    method: 'post',
    params
  });
};

// 统一导入API
export {
  getProductsList,
  getRecordPopGood,
  createAdminProduct,
  getAdminProductsList,
  getAdminWebinarProductsList,
  getAdminUnselectedList,
  createAdminWebinarProduct,
  getAdminProductDetail,
  setAdminProductStatus,
  batchChangeStatus,
  updateAdminProduct,
  deleteAdminProduct,
  copyAdminProduct,
  deleteWebinarProduct,
  setWebinarProductOrder,
  getProductsDetail,
  getProductsOtherInfo,
  getProductsPartner,
  createProductsOrder,
  setProductSettingInGlobal,
  getProductSettingInGlobal,
  setWebinarProductSetting,
  getWebinarProductSetting,
  getMyOrderInfo,
  getOrderList,
  getChannelList,
  exportOrderList,
  getOrderInfo,
  queryGoodsListJson,
  setPushStatus,
  setSaleStatus,
  getWeixinOrderInfo,
  getAvailableList,
  getUnavailableList,
  updateRequestConfig,
  reportGoodsView,
  setPushNum
};
